import { useState, useEffect } from 'react';
import { fetchBoardingPoint } from '../../lib/cruiseDetails';

// The live boarding point via the shared cruiseDetails lookup, for the cruise
// date in hand (null when the screen has none). Boarding moves with the river
// — Panbazar in winter, Uzanbazar in summer — so no screen may hardcode it.
// Until the value arrives (or if it is empty) the neutral phrase keeps every
// sentence true.
export const BOARDING_POINT_FALLBACK = 'the boarding point printed on your ticket';

export function useBoardingPoint(date = null) {
  const [boardingPoint, setBoardingPoint] = useState(BOARDING_POINT_FALLBACK);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const boarding = await fetchBoardingPoint({ date });
      if (!cancelled && boarding?.boarding_point) setBoardingPoint(boarding.boarding_point);
    })();
    return () => { cancelled = true; };
  }, [date]);
  return boardingPoint;
}
